module.exports = __webpack_public_path__ + "img/join4-4-h.c7539571.svg";